import React from "react";
import { Link } from "react-router-dom";
import { Divider, Grid, Menu, Segment, Sidebar } from "semantic-ui-react";
import { faCog, faChartBar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useCategoriesTree from "../../../hooks/useCategoriesTree";
import { isAvailableNow } from "../../../datas/utils";
import { renderCategoryIcon } from "../../../datas/categoryIcons";
import "./categoriessidebar.css";
import { COLOR_1755 } from "../../../_const/_const";
import LogoAnimated from "../LogoAnimated";

const CategoriesSidebar = ({
  user,
  sidebarVisible,
  setSidebarVisible,
  setSelectedCategory,
  children,
}) => {
  const { tree } = useCategoriesTree();

  const visibleTopLevel = tree.filter((c) => {
    if (user) return true;
    return c.visible && isAvailableNow(c.availability);
  });

  return (
    <Grid columns={1}>
      <Grid.Column>
        <Sidebar.Pushable as={Segment}>
          <Sidebar
            style={{ background: COLOR_1755 }}
            as={Menu}
            animation="overlay"
            icon="labeled"
            onHide={() => setSidebarVisible(false)}
            onShow={() => setSidebarVisible(true)}
            vertical
            visible={sidebarVisible}
            width="thin"
          >
            <Link to={`/`} onClick={() => setSelectedCategory({})}>
              <Menu.Item className="categories-sidebar-item">
                <Menu.Header>
                  <LogoAnimated
                    width="100px"
                    imgStyle={{ borderRadius: "100%" }}
                    alt=""
                  />
                </Menu.Header>
              </Menu.Item>
            </Link>
            <Divider />
            {user && (
              <Link
                to="/admin/categories"
                onClick={() => setSidebarVisible(false)}
              >
                <Menu.Item className="categories-sidebar-item">
                  <Menu.Header>
                    <FontAwesomeIcon icon={faCog} size="3x" color="white" />
                  </Menu.Header>
                  <span>Gérer les catégories</span>
                </Menu.Item>
              </Link>
            )}
            {user && (
              <Link to="/admin/stats" onClick={() => setSidebarVisible(false)}>
                <Menu.Item className="categories-sidebar-item">
                  <Menu.Header>
                    <FontAwesomeIcon
                      icon={faChartBar}
                      size="3x"
                      color="white"
                    />
                  </Menu.Header>
                  <span>Statistiques</span>
                </Menu.Item>
              </Link>
            )}
            {visibleTopLevel.map((category) => (
              <Link
                key={category.slug}
                to={`/categories/${category.slug}`}
                onClick={() => {
                  setSelectedCategory(category);
                  setSidebarVisible(false);
                }}
              >
                <Menu.Item className="categories-sidebar-item">
                  <Menu.Header>
                    {renderCategoryIcon(
                      category.icon,
                      category.iconColor || "white",
                      "4x",
                      category.badge,
                    )}
                  </Menu.Header>
                  <span>{category.name}</span>
                </Menu.Item>
              </Link>
            ))}
          </Sidebar>
          <Sidebar.Pusher dimmed={sidebarVisible}>
            <Segment basic>{children}</Segment>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </Grid.Column>
    </Grid>
  );
};

export default CategoriesSidebar;
